import { AxiosInstance } from 'axios';
import { RequestFields } from '../../Utils/types';

export class BaseRepository<T = any> {
  constructor(protected client: AxiosInstance, protected resourcePath: string) {}

  public async get(params: RequestFields = {}) {
    const { entityId, search, filters, ordering, page, rowsPerPage } = params;
    let url = `${this.resourcePath}/`;

    if (entityId) {
      url += `${entityId}/`;
    } else {
      const queryParts: string[] = [];
      if (filters) queryParts.push(...filters);
      if (ordering) queryParts.push(`ordering=${ordering}`);
      if (page) queryParts.push(`page=${page}`);
      if (rowsPerPage) queryParts.push(`page_size=${rowsPerPage}`);
      if (search) queryParts.push(`search=${search}`);

      if (queryParts.length > 0) {
        url += `?${queryParts.join('&')}`;
      }
    }

    return this.client.get(url);
  }

  public async create(data: any) {
    return this.client.post(`${this.resourcePath}/`, data);
  }

  public async update(entityId: string, data: any) {
    return this.client.put(`${this.resourcePath}/${entityId}/`, data);
  }

  public async delete(entityId: string) {
    return this.client.delete(`${this.resourcePath}/${entityId}/`);
  }

  public async getMetadata() {
    return this.client.get(`${this.resourcePath}/metadata/`);
  }
}

